module.exports = __webpack_public_path__ + "img/xiaoxi.f44ee0bb.png";